import { ActionTypes } from '../../constants/ActionTypes';
import { INewsReducer } from '../../interfaces/News';

const INIT_STATE: INewsReducer = {
  news: [],
  newsDetails: null,
  newsLoading: false,
  currentAnnouncementId: '',
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.FETCH_NEWS_SUCCESS: {
      return {
        ...state,
        news: action.payload,
        newsLoading: false,
        newsDetails: null,
      };
    }

    case ActionTypes.GET_NEWS: {
      return {
        ...state,
        news: [],
        newsLoading: true,
        newsDetails: null,
      };
    }

    case ActionTypes.CLEAR_NEWS_ITEM: {
      return {
        ...state,
        currentAnnouncementId: '',
        newsDetails: null,
      };
    }

    case ActionTypes.GET_NEWS_BY_ID: {
      return {
        ...state,
        newsDetails: null,
        newsLoading: true,
        currentAnnouncementId: action.payload,
      };
    }

    case ActionTypes.FETCH_NEWS_BY_ID_SUCCESS: {
      return {
        ...state,
        newsLoading: false,
        newsDetails: action.payload,
      };
    }

    default:
      return state;
  }
};
